import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import * as DOMPurify from 'dompurify';
import { marked } from 'marked';

class MarkedPipe {
    transform(value) {
        return DOMPurify.sanitize(marked.parse(value.replace(/^[\u200B\u200C\u200D\u200E\u200F\uFEFF]/, "")));
    }
}
MarkedPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: MarkedPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
MarkedPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: MarkedPipe, name: "marked" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: MarkedPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'marked',
                }]
        }] });

class MarkdownModule {
}
MarkdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: MarkdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MarkdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: MarkdownModule, declarations: [MarkedPipe], exports: [MarkedPipe] });
MarkdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: MarkdownModule, providers: [MarkedPipe] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: MarkdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MarkedPipe],
                    imports: [],
                    exports: [MarkedPipe],
                    providers: [MarkedPipe],
                    bootstrap: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { MarkdownModule, MarkedPipe };
